export default __webpack_public_path__ + "static/media/plain-sticker-e.488756f5.png";